/**
 * author: Soumya Shreyas
 * Modal Component for confirmation
 */

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";

function ConfirmationModal({ modalShow, messageText, messageSubText, callbackModal, id = "", title = "", confirmButtonText = 'Ok', cancelButtonText = 'Cancel', type }) {
  const [show, setShow] = useState(modalShow);
  const [message, setMessage] = useState(messageText);

  useEffect(() => {
    setShow(modalShow);
  }, [modalShow]);

  useEffect(() => {
    setMessage(messageText);
  }, [messageText]);

  const handleClose = () => {
    setShow(false);
    callbackModal(false, id);
  }

  const handleConfirm = () => {
    setShow(false);
    callbackModal(true, id);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}
        className="builder-confirm-modal"
        backdropClassName="builder-confirm-modal-backdrop"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
				keyboard={false}
      >
        {
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body>
          {
            type === 'FORM_SUBMIT' &&
            <h4 className="text-center">Thank You!</h4>
          }
          <div className="shortDataHeight">
            {message}
            <div>
              {messageSubText}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" className="sbmBtn px-4" onClick={handleClose} >
              {cancelButtonText}
            </Button>
          <Button variant="primary" className="px-4" onClick={handleConfirm}>
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
